import React from 'react'

import LazyImgwrapper from '@nexys/components/LazyImgWrapper'
import { image } from 'constant'
import { Text } from 'shortcuts/Typography'

import classNames from 'views/Home/components/MediaPromotion.module.scss'

interface ICardMediaPromotion {
  title: string
  description: string
  img?: string
  onClick? : () => void
}

const CardMediaPromotion = ({
  title,
  description,
  img = image.ilustrationMedia1,
  onClick = () => {}
}: ICardMediaPromotion) => {
  return (
    <div className={classNames.containerHorz} onClick={onClick}>
      <div className={classNames.containerContent}>
        <LazyImgwrapper className={classNames.lazyImgWrapper}>
          <img src={img} alt={img} className={classNames.img} />
        </LazyImgwrapper>
        <div className={classNames.content}>
          <Text className={classNames.title}>{title}</Text>
          <Text className={classNames.desc}>{description}</Text>
        </div>
      </div>
    </div>
  )
}

export default CardMediaPromotion
